 export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

  export const HOME_API =  "https://thingproxy.freeboard.io/fetch/"+encodeURIComponent("https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9328638&lng=77.6139346&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING")

  // export const HOME_API = 'https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9328638&lng=77.6139346&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING'
  
  export const UPDATE_LIST = "https://thingproxy.freeboard.io/fetch/" + encodeURIComponent('https://www.swiggy.com/dapi/restaurants/list/update')
  // ("https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9328638&lng=77.6139346&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING")

  export const MENU_API = "https://thingproxy.freeboard.io/fetch/"+encodeURIComponent('https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9328638&lng=77.6139346&restaurantId=')


  
//  const LOGO_URL = "../../icons/logo.png";


// export {CDN_URL}